import React from 'react';
import RoleBasedSidebar from './RoleBasedSidebar';

const AppLayout = ({ children, sidebarCollapsed, setSidebarCollapsed }) => {
  return (
    <div className="min-h-screen bg-secondary-50">
      <RoleBasedSidebar 
        isCollapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
      />
      
      <main className={`transition-all duration-300 pt-16 md:pt-20 ${
        sidebarCollapsed ? 'lg:ml-16' : 'lg:ml-60'
      }`}>
        {children}
      </main>
    </div>
  );
};

export default AppLayout; 
